module.exports = __webpack_public_path__ + "static/media/semi.bdecfa20.avif";